// extracted by mini-css-extract-plugin
module.exports = {"social-links":"Social_social-links__2WMsP","social-links__item":"Social_social-links__item__2DPAw"};